import styled from 'styled-components'

export const IframeContainer = styled.div<{ componentStyle?: string }>`
    ${(props) => props.componentStyle}

    overflow: hidden;
    padding: 0px;
    margin: 0px;

    border: var(--dashboard-legend-border);
    border-radius: 5px;

    iframe {
        height: 100%;
        overflow: hidden;
        padding: 0px;
        margin: 0px;
    }
`
